import { render, staticRenderFns } from "./Airlines.vue?vue&type=template&id=64520406&"
import script from "./Airlines.vue?vue&type=script&lang=js&"
export * from "./Airlines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports